import React, { Component } from 'react';
import styleNormalizer from 'react-style-normalizer';
import PropTypes from 'prop-types';

// Local Adress = 'http://localhost:5006/api/GVM/';
//const url = 'http://localhost:5006/api/GVM/';

const url = 'http://gvm.itoperators.dk:5006/api/GVM/';

export default class ReactCompass extends Component {
  constructor(props) {
        super(props);

        this.oldAngle = 0;
    }

  /*state = {
    GV1WinDir: [],
    GV2WinDir: [],
    GV3WinDir: [],
  };

  componentDidMount() {
    this.fetchGeneratorData();
    this.timerID = setInterval(
      () => this.fetchGeneratorData(),
      30000
    );
  }

  componentWillUnmount() {
    clearInterval(this.timerID);
  }

  fetchGeneratorData = async () => {

    let GV1WindCall = await fetch(url + '1', { method: 'GET', headers: { 'Content-Type': 'application/json' , 'Key': 'WindDirection' }});
    let GV2WindCall = await fetch(url + '2', { method: 'GET', headers: { 'Content-Type': 'application/json' , 'Key': 'WindDirection' }});
    let GV3WindCall = await fetch(url + '3', { method: 'GET', headers: { 'Content-Type': 'application/json' , 'Key': 'WindDirection' }});

    await Promise.all([GV1WindCall, GV2WindCall, GV3WindCall])    
      .then(([res1, res2, res3]) => Promise.all([res1.json(), res2.json(), res3.json()]))
      .then(([data1, data2, data3]) => this.setState({
          GV1WinDir: data1,
          GV2WinDir: data2,
          GV3WinDir: data3
      }));
  }*/

  static propTypes = {
      direction: PropTypes.number,
      directionNames: PropTypes.arrayOf(PropTypes.string)
  };

  static defaultProps = {
        direction: 0,
        directionNames: ['N', 'NE', 'E', 'SE', 'S', 'SW', 'W', 'NW']
    };

    directionName(dir) {
        let sections = this.props.directionNames.length,
            sect = 360 / sections,
            x = Math.floor((dir + sect / 2) / sect);

        x = x >= sections ? 0 : x;

        return this.props.directionNames[x];
    }

    normalizeAngle(direction) {
        let newAngle = direction,
            rot = this.oldAngle || 0,
            ar = rot % 360;

        while (newAngle < 0) { newAngle += 360; }
        while (newAngle > 360) { newAngle -= 360; }
        while (rot < 0) { rot += 360; }
        while (rot > 360) { rot -= 360; }

        if (ar < 0) { ar += 360; }
        if (ar < 180 && newAngle > ar + 180) { rot -= 360; }
        if (ar >= 180 && newAngle <= ar - 180) { rot += 360; }

        rot += newAngle - ar;
        this.oldAngle = rot;

        return rot;
    }

  render() {

    let average = Math.round(this.props.direction *10)/10; 
    let dir = this.normalizeAngle(average),    
    name = this.directionName(this.props.direction);      

        return (
            <div className="compass">
                <div className="compass__windrose" >
                    {[...Array(10)].map((k, i) => <div className="compass__mark" key={i + 1}></div>)}
                     
                    <div className="compass__mark--direction-h"></div>
                    <div className="compass__mark--direction-v"></div>
                </div>
                <div className="compass__arrow-container">
                    <div className="compass__arrow" style={styleNormalizer({ transform: `rotate(${this.props.direction + 45}deg)` })}></div>
                    <div className="compass__labels">
                        <span>{name}</span>
                        <span>{this.props.speed} m/s</span>
                    </div>
                </div>
            </div>
        );
  }
}



// WEBPACK FOOTER //
// ./src/features/home/ReactCompass.js